import type { ComputedRef, InjectionKey, Ref } from 'vue'
import type { EstimatedTimeName } from '../EstimatedTimeName'

export interface AddEstimatedTimeNamePayload {
  code: string
  name: string
  referenceTime: string
  isInactive?: boolean
}

export type UpdateEstimatedTimeNamePayload =
  Partial<AddEstimatedTimeNamePayload>

export interface EstimatedTimeNamesService {
  /** All entries, including inactive. */
  estimatedTimeNames: Ref<EstimatedTimeName[]>
  /** Active subset, sorted by `referenceTime`. Convenience for selectors. */
  activeEstimatedTimeNames: ComputedRef<EstimatedTimeName[]>
  isLoading: { estimatedTimeNames: boolean }
  /** Fetch the registry. No-op after first success unless `forceFetch`. */
  fetch(params?: { forceFetch?: boolean }): Promise<EstimatedTimeName[]>
  add(payload: AddEstimatedTimeNamePayload): Promise<EstimatedTimeName>
  update(
    id: string,
    payload: UpdateEstimatedTimeNamePayload
  ): Promise<EstimatedTimeName>
  remove(id: string): Promise<void>
  /** Resolve a label by matching `HH:mm:ss` to `referenceTime`. */
  findByReferenceTime(referenceTime: string): EstimatedTimeName | undefined
}

export const estimatedTimeNamesKey = Symbol(
  'gs-estimated-time-names'
) as InjectionKey<EstimatedTimeNamesService>
